module.exports = __webpack_public_path__ + "static/media/LOGO-GP-vert-RVB-300x47.7480cc2d.png";